import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import "../HorizontalBarChart/HorizontalBarChart.css";

const data = [
  { ReportCount: 5000, Reports: "Report Under Process", legend: "Process" },
  { ReportCount: 3000, Reports: "Report Under Review", legend: "Review" },
];

const CustomBar = (props) => {
  const { fill, x, y, width, height } = props;
  const radius = 5; // Rounded corner radius
  const effectiveRadius = Math.min(radius, height / 2); // Ensures radius doesn't exceed bar height

  return (
    <path
      d={`M${x},${y}
         h${width - effectiveRadius}
         a${effectiveRadius},${effectiveRadius} 0 0,1 ${effectiveRadius},${effectiveRadius}
         v${height - effectiveRadius * 2}
         a${effectiveRadius},${effectiveRadius} 0 0,1 -${effectiveRadius},${effectiveRadius}
         h-${width - effectiveRadius}
         v-${height}
         Z`}
      fill={fill}
    />
  );
};

const colors = ["#5662be", "#efc58a"];

const HorizontalBarChart = () => {
  // Update the data to replace the names
  const updatedData = data.map((item) => {
    if (item.Reports === "Report Under Review") {
      return { ...item, Reports: "Report in Review" };
    }
    if (item.Reports === "Report Under Process") {
      return { ...item, Reports: "Report in Process" };
    }
    return item;
  });
  return (
    <>
      <section className="section">
        <div className="horizontal-container">
          <div className="horizontal-header">
            <h1>Report Status: Process vs. Review <sub style={{color: "blue"}}>(Horizontal bar chart)</sub></h1>
          </div>

          <div className="horizontal-parent">
            <div className="horizontal-count-wrapper">
              <div>
                <i class="fa-solid fa-circle" style={{ color: "#5662be" }}></i>{" "}
                Process
              </div>
              <div>
                <i class="fa-solid fa-circle" style={{ color: "#efc58a" }}></i>{" "}
                Review
              </div>
            </div>

            <div className="horizontal-chart-container">
              <ResponsiveContainer width="100%" height={330}>
                <BarChart
                  layout="vertical" // Horizontal bars
                  data={updatedData} // Use the updated data
                  margin={{ top: 5, right: 20, left: -70, bottom: 40 }}
                >
                  <CartesianGrid
                    stroke="#d6d6d6"
                    strokeDasharray="0 0"
                    horizontal={false}
                    vertical={true}
                  />

                  {/* X-Axis for ReportCount */}
                  <XAxis
                    type="number"
                    tick={{ fontSize: "14px", fill: "#999" }} // Updated font size and color for ticks
                    axisLine={{
                      stroke: "rgb(167, 167, 167)",
                      strokeWidth: 1.7,
                    }} // X-axis line color and thickness
                    label={{
                      value: "Report Count", // Title of the X-axis
                      position: "insideLeft", // Position of the title
                      offset: 0, // Adjusts the position of the label
                      style: { fontSize: "14px", fill: "#999" }, // Updated font size and color
                      dy: 30,
                    }}
                  />

                  {/* Y-Axis for Reports */}
                  <YAxis
                    dataKey="Reports"
                    type="category"
                    width={200}
                    tick={{ fontSize: 14, fill: "#999" }} // Set tick style
                    axisLine={{
                      stroke: "rgb(167, 167, 167)",
                      strokeWidth: 1.7,
                    }} // Y-axis line color and thickness
                  />

                  <Tooltip
                    cursor={{ fill: "transparent" }}
                    labelStyle={{
                      fontSize: "14px", // Updated tooltip label font size
                      color: "#000", // Updated tooltip label color
                    }}
                    itemStyle={{
                      fontSize: "14px", // Updated tooltip item font size
                      color: "#999", // Updated tooltip item color
                    }}
                    formatter={(value) => [`${value}k`, "Reports Count"]}
                  />

                  <Bar
                    dataKey="ReportCount"
                    isAnimationActive={false} // Disables hover animation
                    onMouseEnter={(data, index, e) => {
                      // Optionally handle hover event here
                    }}
                    onMouseLeave={(data, index, e) => {
                      // Optionally handle hover event here
                    }}
                    shape={(props) => {
                      // Pass dynamic color based on the index of the data
                      const color = colors[props.index % colors.length];
                      return <CustomBar {...props} fill={color} />;
                    }}
                    barSize={35}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HorizontalBarChart;
